import { render, staticRenderFns } from "./dash-ke.vue?vue&type=template&id=13ef3b20&"
import script from "./dash-ke.vue?vue&type=script&lang=js&"
export * from "./dash-ke.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports